import React from 'react';
import { Grid, Flex, Divider, Skeleton, SkeletonText } from '@televet/kibble-ui';

const AutomationSettingsSkeleton = (): JSX.Element => {
  return (
    <Flex direction="column" gap={4} mt="25px">
      <Skeleton height="20px" width={'170px'}></Skeleton>
      <SkeletonText noOfLines={2}></SkeletonText>
      <SkeletonText noOfLines={1} mt="20px"></SkeletonText>
      <Grid templateColumns="repeat(3, 1fr)" gap={4} mt="15px">
        <Skeleton height="20px" width="100%"></Skeleton>
        <Skeleton height="20px" width="100%"></Skeleton>
        <Skeleton height="20px" width="100%"></Skeleton>
      </Grid>
      <Skeleton mt="4px" height="30px"></Skeleton>
      <Skeleton mt="4px" height="30px"></Skeleton>
      <Skeleton mt="4px" height="30px"></Skeleton>
      <Skeleton mt="4px" height="30px"></Skeleton>
      <Skeleton mt="4px" height="30px"></Skeleton>
      <Skeleton mt="4px" height="30px"></Skeleton>
      <Skeleton mt="4px" height="30px"></Skeleton>
    </Flex>
  );
};

const GeneralSettingsSkeleton = (): JSX.Element => {
  return (
    <Flex direction="column" gap={5} mt="40px">
      <Divider />
      <Skeleton height="20px" width={'170px'}></Skeleton>
      <SkeletonText noOfLines={1}></SkeletonText>
      <Skeleton height="20px" width={'170px'}></Skeleton>
      <SkeletonText noOfLines={1}></SkeletonText>
      <Skeleton height="20px" width="300px" mt="10px"></Skeleton>
      <Divider />
      <Skeleton height="20px" width={'170px'} mt="20px"></Skeleton>
      <SkeletonText noOfLines={1}></SkeletonText>
      <Skeleton height="20px" width="300px" mt="10px"></Skeleton>
    </Flex>
  );
};

export { GeneralSettingsSkeleton, AutomationSettingsSkeleton };
